/* Wrenfold — the one motion rule and the few bits of interaction the design needs.
   Reveal logic ported from the DCLogic script in "Wrenfold Home.dc.html". */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fade + 14px rise, 650ms, stagger 90ms — see design-system.md "Motion" */
  function watchReveals() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.setProperty('--d', String(en.target.dataset.d || 0));
        en.target.classList.add('wf-reveal');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    var tick = function () {
      document.querySelectorAll('[data-reveal]:not(.wf-reveal)').forEach(function (el, i) {
        el.dataset.d = String(i % 4);
        io.observe(el);
      });
    };
    tick();
    setTimeout(tick, 400);
  }

  function burger() {
    var btn = document.querySelector('[data-wf-burger]');
    var nav = document.getElementById('wf-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* product gallery: thumbnails swap the main image */
  function gallery() {
    var main = document.querySelector('[data-wf-main-image]');
    if (!main) return;
    document.querySelectorAll('[data-wf-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (!src) return;
        main.setAttribute('src', src);
        main.removeAttribute('srcset');
        document.querySelectorAll('[data-wf-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  function qty() {
    document.querySelectorAll('[data-wf-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchReveals();
    burger();
    gallery();
    qty();
  });
})();
